import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isNil from 'lodash/isNil';
import isNull from 'lodash/isNull';
import merge from 'lodash/merge';
import { BaseEventType } from './base';

const HOME_SIZE_OPTIONS = [
  'studio',
  'one_bed',
  'two_bed',
  'three_bed',
  'three_bed_plus',
  'four_bed_plus',
];

const OWNERSHIP_OPTIONS = ['rent', 'own'];

export const AuthenticatedEventType = merge({}, BaseEventType, {
  channel: (val) => isString(val) && !isEmpty(val),
  user: {
    email: (val) =>
      isString(val) &&
      !isEmpty(val) &&
      /^[A-Z0-9.!#$%&'*+/=?^_`{|}~\-"\\]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val),
    uuid: (val) =>
      isString(val) &&
      !isEmpty(val) &&
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/.test(
        val
      ),
    moveId: (val) =>
      isString(val) && !isEmpty(val) && isNumber(parseInt(val, 10)),
    test: (val) => isBoolean(val),
    move: {
      id: (val) =>
        isString(val) && !isEmpty(val) && isNumber(parseInt(val, 10)),
      ownership: (val) =>
        isEmpty(val) || (isString(val) && OWNERSHIP_OPTIONS.includes(val)),
      direction: (val) => isString(val) || isNull(val),
      days_from_signup_to_move_date: (val) => isNumber(val),
      days_to_move_date: (val) => isNumber(val),
      signed_up_after_move_date: (val) => isBoolean(val) || isNull(val),
      today_is_after_move_date: (val) => isBoolean(val) || isNull(val),
      to_home_size: (val) =>
        (isString(val) && HOME_SIZE_OPTIONS.includes(val)) || isNil(val),
      from_home_size: (val) =>
        (isString(val) && HOME_SIZE_OPTIONS.includes(val)) || isNil(val),
    },
  },
});
